export default __webpack_public_path__ + "static/media/avatar.43d5b445.jpg";